import { render, staticRenderFns } from "./task-tech-list.vue?vue&type=template&id=cb80c680&scoped=true"
import script from "./task-tech-list.vue?vue&type=script&lang=js"
export * from "./task-tech-list.vue?vue&type=script&lang=js"
import style0 from "./task-tech-list.vue?vue&type=style&index=0&id=cb80c680&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb80c680",
  null
  
)

export default component.exports